export const ENTITY_TYPES = {
  COURSES: "courses",
  LEVELS: "levels",
};

export const TAB_TYPES = {
  TODDLE: "TODDLE",
  CUSTOM: "CUSTOM",
};

export const CELL_TYPES = {
  TEXT: "text",
  DROPDOWN: "dropdown",
  ICON: "icon",
  LABEL: "label",
  SKELETON: "skeleton",
  TOGGLE: "toggle",
};

export const COLUMN_TYPES = {
  TITLE: "TITLE",
  NAME: "NAME",
  APPLICABLE_GRADES: "APPLICABLE_GRADES",
  USED_IN_TRANSCRIPTS: "USED_IN_TRANSCRIPTS",
  INCLUDE_IN_GPA: "INCLUDE_IN_GPA",
  DELETE: "DELETE",
};

export const TAB_WISE_COLUMNS = {
  [TAB_TYPES.TODDLE]: [COLUMN_TYPES.TITLE, COLUMN_TYPES.APPLICABLE_GRADES],
  [TAB_TYPES.CUSTOM]: [
    COLUMN_TYPES.NAME,
    COLUMN_TYPES.USED_IN_TRANSCRIPTS,
    COLUMN_TYPES.INCLUDE_IN_GPA,
    COLUMN_TYPES.DELETE,
  ],
};
